import React, { useRef } from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { DatepickerIcon } from '../../../shared/components/Icons/Datepicker';
import { CaledarIcon } from '../../../shared/components/Icons/CalendarIcon';
import Button from '../Button';
import * as Styled from './styles';
import { getBoundingClientRect } from '../../../helpers/coordinates';

export const MenuDatepickerButton = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { withAnnouncements } = window.Widget.settings;
  const calendarRef = useRef<HTMLDivElement>();
  const { width: rootWidth, top: rootTop, left: rootOffsetLeft } = window.Widget.rootLayout;

  const openCalendar = () => {
    const { top, left, height, width } = getBoundingClientRect(calendarRef.current);

    window.Widget.calendarController.show({
      top: top + height - rootTop,
      right: rootWidth + rootOffsetLeft - left - width,
    });
  };

  if (withAnnouncements) {
    <Styled.DatepickerButtonWithAnnouncements ref={calendarRef}>
      <Button onClick={openCalendar}>
        {!theme.isMobile ? <DatepickerIcon /> : t('selectDate')}
      </Button>
    </Styled.DatepickerButtonWithAnnouncements>;
  }

  return (
    <Styled.DatepickerButtonContainer ref={calendarRef}>
      <Styled.DatepickerButton onClick={openCalendar}>
        <CaledarIcon /> <Styled.DatepickerText>{t('otherDates')}</Styled.DatepickerText>
      </Styled.DatepickerButton>
    </Styled.DatepickerButtonContainer>
  );
};
